import { render, staticRenderFns } from "./datModal.vue?vue&type=template&id=4b04db56"
import script from "./datModal.vue?vue&type=script&lang=js"
export * from "./datModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports